const FAQ = [
  {
    question: 'Do you serve nuts?',
    answer: 'We are a nut-free facility and have no nut items in any of our menu items.  However, we do source bread from a local baker that has nuts in their building, so there is a potential for cross contamination.',
  },
  {
    question: 'What if my child has a food allergy?',
    answer: 'Read each meal ingredients to ensure that the allergen is not part of the description.  As much as we would love to feed all students, we would rather not have you order if your child has extreme food allergies.  Our goal is to keep them as healthy as possible.  For additional information, please contact us at hello@mybetterlunch.com.  We are happy to help!',
  },
  {
    question: 'When can I order lunch?',
    answer: 'Menus are posted in 2-month increments.  To take advantage of ALL offerings, please order 36-hours before our 8AM cut-off time.  During this 36-hour window of day of service, you will have limited options to choose from.',
  },
  {
    question: 'What comes with the lunch?',
    answer: '2 rotating side items are included with each entrée ordered.  We provide all cutlery, napkin, condiments; and dipping sauces when noted on menu.',
  },
  {
    question: 'Can I make changes or substitutions to menu items?',
    answer: 'Unfortunately, no.  We have found that by trying to accommodate each special request, we cannot feed each student in a timely manner.',
  },
  {
    question: 'What if my child is sick and I have ordered lunch?',
    answer: 'Simply email hello@mybetterlunch prior to 8AM day of service to cancel your order.  We will process the cancellation and the funds will be applied to your account for future lunch orders',
  },
  {
    question: 'How often do I have to order lunch?',
    answer: 'As much as you would like! Some parents order every day for their child; some once a week.',
  },
  {
    question: 'Why can’t I order for the entire year at one time?',
    answer: 'At Better Lunch we try new recipes, source different products and will remove items that kids are not loving and replace them with things they do!',
  },
  {
    question: 'How can I get technical assistance with ordering?',
    answer: 'Send an email to hello@mybetterlunch.com',
  },
  {
    question: 'What is my “SCHOOL CODE”?',
    answer: 'Please contact your school for this code, or email us at hello@mybetterlunch.com and include the name of your child(ren) school and we will provide you with this.',
  },
];

export default FAQ;
